import imagesLoaded from './imagesloaded.js';

{

	let titles = document.querySelectorAll( '.hero__text' );
	let images = document.querySelectorAll( '.hero__slide' );
	let totalSlides = titles.length;
	let currentSlide = 0;
	let lastSlide;

	function nextSlide() {

		lastSlide = currentSlide;

		setTimeout( function() {

			titles[lastSlide].classList.remove( 'hero__text--animate' );
			images[lastSlide].classList.remove( 'hero__slide--active' );

		}, 200 );

		currentSlide = ( currentSlide === ( totalSlides - 1 ) ) ? 0 : ( currentSlide + 1 );

		titles[currentSlide].classList.add( 'hero__text--animate' );
		images[currentSlide].classList.add( 'hero__slide--active' );

	}

	let hero = document.querySelector( '.hero--home' );

	if( hero ) {

		images[0].classList.add( 'hero__slide--active' );

		imagesLoaded( images[0], {background: true}, function() {

			titles[0].classList.add( 'hero__text--animate' );

		} );

		if( totalSlides > 1 ) {

			imagesLoaded( '.hero__slide', {background: true}, function() {

				setInterval( nextSlide, 4800 );

			} );

		}

	}

}

//Product single slider
var singleProduct = document.querySelectorAll( '.single-product__col--images' );

if(singleProduct.length > 0) {
	var productImages = document.querySelectorAll( '[data-product-slider] div' );
	var totalProductSlides = productImages.length;
	var currentProductSlide = 0;
	var lastProductSlide;
	
	productImages[0].classList.add( 'current-slide' );
	
	setInterval( nextSlide, 3000 );
	
	function nextSlide() {
	
		lastProductSlide = currentProductSlide;
	
		setTimeout( function() {
	
			productImages[lastProductSlide].classList.remove( 'current-slide' );
	
		}, 200 );
	
		currentProductSlide = ( currentProductSlide === ( totalProductSlides - 1 ) ) ? 0 : ( currentProductSlide + 1 );
	
		productImages[currentProductSlide].classList.add( 'current-slide' );
	}
}


/** WEBPACK FOOTER **
 ** slider.js
 **/